module.exports = __webpack_public_path__ + "img/logo.8c92c345.png";